import { TRANSLATE_PREFIX } from './consts';

export const LOAD_INTEGRATION_REQUESTS_STARTED = 'partnerIntegration/LOAD_INTEGRATION_REQUESTS_STARTED';
export const LOAD_INTEGRATION_REQUESTS_SUCCEEDED = 'partnerIntegration/LOAD_INTEGRATION_REQUESTS_SUCCEEDED';
export const LOAD_INTEGRATION_REQUESTS_FAILED = 'partnerIntegration/LOAD_INTEGRATION_REQUESTS_FAILED';
export const ADD_INTEGRATION_REQUEST = 'partnerIntegration/ADD_INTEGRATION_REQUEST';
export const UPDATE_INTEGRATION_REQUEST = 'partnerIntegration/UPDATE_INTEGRATION_REQUEST';

export const loadIntegrationRequestsStarted = () => ({
    type: LOAD_INTEGRATION_REQUESTS_STARTED,
});

export const loadIntegrationRequestsSucceeded = (requests, postbackMacroNetworkName = null) => ({
    type: LOAD_INTEGRATION_REQUESTS_SUCCEEDED,
    requests,
    postbackMacroNetworkName,
});

export const loadIntegrationRequestsFailed = error => ({
    type: LOAD_INTEGRATION_REQUESTS_FAILED,
    error,
});

export const addIntegrationRequest = request => ({
    type: ADD_INTEGRATION_REQUEST,
    request,
});

export const updateIntegrationRequest = request => ({
    type: UPDATE_INTEGRATION_REQUEST,
    request,
});

export const fetchIntegrationRequests = ({ dispatch, service }) => {
    dispatch(loadIntegrationRequestsStarted());
    return service
        .getIntegrationRequests()
        .then(({ requests, postbackMacroNetworkName }) => {
            dispatch(loadIntegrationRequestsSucceeded(requests, postbackMacroNetworkName));
        })
        .catch(() => {
            dispatch(loadIntegrationRequestsFailed(`${TRANSLATE_PREFIX}.ERRORS.LOAD_REQUESTS`));
        });
};
